import sha1 from 'sha1';

export default (ranges: $TSFixMe) => sha1(JSON.stringify(ranges));
